import { render, staticRenderFns } from "./RankingDetailsModal.vue?vue&type=template&id=5302a5c0&scoped=true"
import script from "./RankingDetailsModal.vue?vue&type=script&lang=js"
export * from "./RankingDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./RankingDetailsModal.vue?vue&type=style&index=0&id=5302a5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5302a5c0",
  null
  
)

export default component.exports